import React from "react";

interface IconProps {
  className?: string;
}

export const DestinationIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
      fill="#FAF8F5"
    />
    <g clipPath="url(#dest_clip)">
      <path
        d="M24.23 13.76C23.1 12.62 21.59 12 19.99 12C18.39 12 16.88 12.62 15.74 13.76C14.05 15.45 13.6 17.91 14.36 20.02C14.5 20.44 14.69 20.84 14.93 21.22L15.04 21.39L19.15 27.56C19.55 28.15 20.42 28.15 20.81 27.56L24.92 21.39L25.03 21.22C25.27 20.84 25.45 20.44 25.6 20.03C26.37 17.91 25.92 15.45 24.23 13.76ZM19.99 20C18.89 20 17.99 19.1 17.99 18C17.99 16.9 18.89 16 19.99 16C21.09 16 21.99 16.9 21.99 18C21.99 19.1 21.09 20 19.99 20Z"
        fill="#6B6760"
      />
    </g>
    <defs>
      <clipPath id="dest_clip">
        <rect width="16" height="16" fill="white" transform="translate(12 12)" />
      </clipPath>
    </defs>
  </svg>
);

export const CategoriesIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
      fill="#FAF8F5"
    />
    <g clipPath="url(#cat_clip)">
      <path
        d="M27.49 13.4603L27.33 13.3903C26.61 13.1203 24.75 12.6403 22.76 12.6403C19.7 12.6403 18.1 13.4203 18.02 13.4603C17.72 13.6303 17.52 13.9803 17.52 14.3403V15.4603C17.38 15.4703 17.25 15.4903 17.1 15.5103H17C14.8 15.8303 13.14 16.5803 12.52 16.9603C12.27 17.0903 12 17.3503 12 17.9403L12.71 22.8403C13.08 25.4103 15.3 27.3503 17.88 27.3503C18.18 27.3503 18.41 27.3303 18.63 27.3003C20.02 27.1103 21.25 26.3903 22.07 25.2703C22.24 25.0503 22.43 24.8003 22.58 24.5303C22.63 24.5303 22.69 24.5303 22.76 24.5303C25.65 24.5303 28 22.1803 28 19.2903V14.3403C28 13.9703 27.8 13.6203 27.49 13.4603ZM20.62 24.1203C20.07 24.8503 19.27 25.3203 18.35 25.4503L18.21 25.4703C16.45 25.6403 14.84 24.3703 14.58 22.5903L13.96 18.2903C14.62 17.9903 15.71 17.6103 17.27 17.3803C18.97 17.1403 20.12 17.2603 20.63 17.3403L21.25 21.6403C21.38 22.5203 21.16 23.4103 20.62 24.1203ZM26.13 19.3003C26.13 21.0703 24.75 22.5303 23.02 22.6503C23.07 22.2403 23.06 21.8203 22.99 21.3903L22.96 21.2203H24.45C24.64 21.2203 24.81 21.1403 24.9 21.0103C24.99 20.8903 25.01 20.7303 24.97 20.6003C24.81 19.5303 23.88 18.7603 22.75 18.7603C22.71 18.7603 22.66 18.7603 22.61 18.7603L22.28 16.4603C22.18 16.0903 21.98 15.8603 21.67 15.7703V15.7903C21.25 15.5703 19.92 15.4903 19.38 15.4803V14.9303C19.88 14.7703 21.04 14.4903 22.75 14.4903C24.46 14.4903 25.61 14.7703 26.12 14.9303V19.2803L26.13 19.3003Z"
        fill="#6B6760"
      />
      <path
        d="M24.38 15.7903C23.8 15.7903 23.32 16.2603 23.32 16.8203C23.32 17.3803 23.81 17.8503 24.38 17.8503C24.91 17.8503 25.38 17.3703 25.38 16.8203C25.38 16.2703 24.91 15.7903 24.38 15.7903Z"
        fill="#6B6760"
      />
      <path
        d="M16.13 20.9103C16.41 20.8703 16.67 20.7203 16.84 20.4903C17 20.2703 17.07 20.0103 17.03 19.7503C16.99 19.4903 16.84 19.2403 16.61 19.0703C16.39 18.9103 16.12 18.8303 15.88 18.8803C15.6 18.9203 15.34 19.0703 15.17 19.3003C15.01 19.5203 14.94 19.7803 14.98 20.0403C15.06 20.5603 15.48 20.9203 15.98 20.9203C16.03 20.9203 16.08 20.9203 16.13 20.9103Z"
        fill="#6B6760"
      />
      <path
        d="M19.16 20.4803C19.21 20.4803 19.26 20.4803 19.31 20.4703C19.84 20.3803 20.22 19.8503 20.14 19.3103C20.06 18.7403 19.54 18.3603 18.99 18.4403C18.71 18.4803 18.45 18.6303 18.28 18.8603C18.12 19.0803 18.05 19.3403 18.09 19.6003C18.16 20.1103 18.64 20.4803 19.16 20.4803Z"
        fill="#6B6760"
      />
      <path
        d="M19.62 21.7403L16.15 22.2203C16.01 22.2403 15.88 22.3203 15.8 22.4503C15.72 22.5803 15.7 22.7403 15.75 22.8903C16.1 23.8103 16.94 24.4003 17.86 24.4003C17.96 24.4003 18.07 24.4003 18.17 24.3803C19.24 24.2403 20.05 23.3803 20.13 22.2903C20.17 22.1503 20.13 22.0203 20.05 21.9103C19.95 21.7903 19.78 21.7203 19.62 21.7503V21.7403Z"
        fill="#6B6760"
      />
    </g>
    <defs>
      <clipPath id="cat_clip">
        <rect width="16" height="16" fill="white" transform="translate(12 12)" />
      </clipPath>
    </defs>
  </svg>
);

export const ProductsIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
      fill="#FAF8F5"
    />
    <g clipPath="url(#prod_clip)">
      <path
        d="M22.3663 18.7835C22.0405 18.7835 21.7914 19.0326 21.7914 19.3584V20.6997C21.7914 21.0254 22.0405 21.2745 22.3663 21.2745C22.692 21.2745 22.9411 21.0254 22.9411 20.6997V19.3584C22.9411 19.0326 22.692 18.7835 22.3663 18.7835Z"
        fill="#6B6760"
      />
      <path
        d="M27.2908 19.2338C27.6932 19.138 27.9998 18.7548 27.9998 18.3428V15.9476C27.9998 15.2674 27.425 14.7021 26.7543 14.7021H13.2453C12.5747 14.7021 11.9998 15.2769 11.9998 15.9476V18.3428C11.9998 18.7644 12.316 19.1476 12.728 19.2338C13.0824 19.3009 13.3411 19.6362 13.3411 20.0003C13.3411 20.3644 13.0824 20.6901 12.7375 20.7572C12.2777 20.8338 11.9902 21.1787 11.9902 21.6482V24.053C11.9902 24.7332 12.5651 25.2985 13.2357 25.2985H26.7351C27.4154 25.2985 27.9807 24.7236 27.9807 24.053V21.6482C27.9807 21.1787 27.6836 20.8338 27.2429 20.7572C26.898 20.6901 26.6298 20.3644 26.6298 20.0003C26.6298 19.6362 26.898 19.3105 27.2717 19.2338H27.2908ZM26.0741 17.6626C25.2597 18.132 24.7232 19.023 24.7232 20.0003C24.7232 20.9775 25.2597 21.8686 26.0741 22.338V23.3727H22.9411V22.7021C22.9411 22.3763 22.692 22.1272 22.3663 22.1272C22.0405 22.1272 21.7914 22.3763 21.7914 22.7021V23.3727H13.9256V22.338C14.7399 21.8686 15.2765 20.9871 15.2765 20.0003C15.2765 19.0135 14.7399 18.132 13.9256 17.6626V16.6278H21.7914V17.2985C21.7914 17.6242 22.0405 17.8733 22.3663 17.8733C22.692 17.8733 22.9411 17.6242 22.9411 17.2985V16.6278H26.0741V17.6626Z"
        fill="#6B6760"
      />
    </g>
    <defs>
      <clipPath id="prod_clip">
        <rect width="16" height="16" fill="white" transform="translate(12 12)" />
      </clipPath>
    </defs>
  </svg>
);

export const CollectionsIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
      fill="#FAF8F5"
    />
    <path
      d="M15 16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16C13 15.4477 13.4477 15 14 15C14.5523 15 15 15.4477 15 16Z"
      fill="#6B6760"
    />
    <path
      d="M15 20C15 20.5523 14.5523 21 14 21C13.4477 21 13 20.5523 13 20C13 19.4477 13.4477 19 14 19C14.5523 19 15 19.4477 15 20Z"
      fill="#6B6760"
    />
    <path
      d="M15 24C15 24.5523 14.5523 25 14 25C13.4477 25 13 24.5523 13 24C13 23.4477 13.4477 23 14 23C14.5523 23 15 23.4477 15 24Z"
      fill="#6B6760"
    />
    <path
      d="M16 16C16 15.4477 16.4477 15 17 15H26C26.5523 15 27 15.4477 27 16C27 16.5523 26.5523 17 26 17H17C16.4477 17 16 16.5523 16 16Z"
      fill="#6B6760"
    />
    <path
      d="M16 20C16 19.4477 16.4477 19 17 19H26C26.5523 19 27 19.4477 27 20C27 20.5523 26.5523 21 26 21H17C16.4477 21 16 20.5523 16 20Z"
      fill="#6B6760"
    />
    <path
      d="M16 24C16 23.4477 16.4477 23 17 23H26C26.5523 23 27 23.4477 27 24C27 24.5523 26.5523 25 26 25H17C16.4477 25 16 24.5523 16 24Z"
      fill="#6B6760"
    />
  </svg>
);
